// Redux Tickettypes module
// see https://github.com/erikras/ducks-modular-redux

import { Customers } from '../../services/';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer,
    startCreateReducer, createReducer, deleteReducer, resetReducer,
    getAction, listAction, updateAction,
    startCreateAction, createAction, deleteAction, resetAction
} = createRestSlices(Customers);

initialState.filters                     = { 'status': 'activated' };

const LOADING_INACTIVE_CUSTOMERS         = 'kronos/customers/LOADING_INACTIVE_CUSTOMERS';
const LOADING_INACTIVE_CUSTOMERS_SUCCESS = 'kronos/customers/LOADING_INACTIVE_CUSTOMERS_SUCCESS';
const LOADING_INACTIVE_CUSTOMERS_FAILURE = 'kronos/customers/LOADING_INACTIVE_CUSTOMERS_FAILURE';
const UPDATING_FILTERS                   = 'kronos/customers/UPDATING_FILTERS';


// Reducer
const reducer = (state, action) => {
    switch(action.type) {
        case LOADING_INACTIVE_CUSTOMERS:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case LOADING_INACTIVE_CUSTOMERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                inactive_customers: action.customers
            };
        case LOADING_INACTIVE_CUSTOMERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case UPDATING_FILTERS:
            return {
                ...state,
                filters: action.filters,
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer,
        startCreateReducer, createReducer, deleteReducer, resetReducer,
        reducer
    ]);
}

/* Export CRUD actions */
export const startCreateCustomer = startCreateAction;
export const createCustomer      = createAction;
export const loadCustomer        = getAction;
export const resetCustomers      = resetAction;
export const loadCustomers       = listAction;
export const updateCustomer      = updateAction;
export const deleteCustomer      = deleteAction;

export function updateCustomersFilters(filters) {
    return (dispatch) => {
        dispatch({ type: UPDATING_FILTERS, filters });
    }
}

function loadingInactiveCustomers() { return { type: LOADING_INACTIVE_CUSTOMERS } }
function loadingInactiveCustomersSuccess(customers) { return { type: LOADING_INACTIVE_CUSTOMERS_SUCCESS, customers: customers } }
function loadingInactiveCustomersFailure(err) { return { type: LOADING_INACTIVE_CUSTOMERS_FAILURE, error: err } }
export function loadInactiveCustomers() {
    return (dispatch) => {
        dispatch(loadingInactiveCustomers());
        Customers.inactive()
            .then(data => {
                const customers = data.customers;
                dispatch(loadingInactiveCustomersSuccess(customers));
            })
            .catch(err => {
                dispatch(loadingInactiveCustomersFailure(err))
            });
    }
}
